if(!customElements.get('cnx-case-options'))customElements.define('cnx-case-options',class extends HTMLElement{
async connectedCallback(){
if(this.started)return;this.started=true;
this.words=this.querySelector('[data-option-words]').dataset;
this.design=this.designOf(this.dataset.title);
if(!this.design)return;
try{
const response=await fetch(this.dataset.models);if(!response.ok)throw Error();
this.models=await response.json();
const tags=JSON.parse(this.querySelector('[data-option-tags]').textContent);
this.model=this.models.find(m=>tags.includes(m.tag))||this.models.find(m=>tags.includes(m.name));
if(!this.model)return;
this.querySelector('[data-current-model]').textContent=this.model.name;
this.querySelector('[data-current-design]').textContent=this.design;
this.querySelector('[data-model-search]').addEventListener('input',()=>this.renderModels());
this.querySelector('[data-design-search]').addEventListener('input',()=>this.renderDesigns());
this.querySelector('[data-model-picker]').addEventListener('toggle',e=>{if(e.target.open){this.querySelector('[data-design-picker]').open=false;this.loadModels();}});
this.querySelector('[data-design-picker]').addEventListener('toggle',e=>{if(e.target.open){this.querySelector('[data-model-picker]').open=false;this.loadDesigns();}});
this.addEventListener('keydown',e=>{if(e.key==='Escape'){const open=this.querySelector('details[open]');if(open){open.open=false;open.querySelector('summary').focus();}}});
this.hidden=false;
}catch{}
}
normalise(s){return String(s).normalize('NFKC').toLowerCase().replace(/[^\p{L}\p{N}]/gu,'');}
designOf(title){const parts=String(title).split(/ Protective Case Cover Printed Featuring /i);return parts.length>1?parts.slice(1).join(' Protective Case Cover Printed Featuring ').trim():'';}
link(path){const url=new URL(path,location.origin);const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);return url.href;}
async collect(start){
let url=new URL(this.link(start)),items=[],seen=new Set(),seenPages=new Set();
while(url){
url.searchParams.set('section_id','cnx-case-option-data');
if(seenPages.has(url.href))throw Error();seenPages.add(url.href);
const response=await fetch(url);if(!response.ok)throw Error();
const doc=new DOMParser().parseFromString(await response.text(),'text/html');
const block=doc.querySelector('[data-case-options-json]');if(!block)throw Error();
const data=JSON.parse(block.textContent);
for(const p of data.products){if(!seen.has(p.id)){seen.add(p.id);items.push(p);}}
url=data.next?new URL(this.link(data.next)):null;
}
return items;
}
async loadModels(){
if(this.sameDesign){this.renderModels();return;}if(this.modelLoading)return;
this.modelLoading=true;const status=this.querySelector('[data-model-status]');status.textContent=this.words.loading;
try{
const url=new URL(this.dataset.search,location.origin);url.searchParams.set('type','product');
url.searchParams.set('q','tag:printed AND title:"'+this.design.replace(/["\\]/g,' ')+'"');
this.sameDesign=(await this.collect(url.href)).filter(p=>this.normalise(this.designOf(p.title))===this.normalise(this.design));
this.renderModels();
}catch{status.textContent=this.words.error;}finally{this.modelLoading=false;}
}
renderModels(){
if(!this.sameDesign)return;
const query=this.normalise(this.querySelector('[data-model-search]').value);
const candidates=this.models.map(model=>{const products=this.sameDesign.filter(p=>p.tags.includes(model.tag)||p.tags.includes(model.name));return {model,product:products.find(p=>p.available)||products[0]};});
const matches=candidates.filter(x=>query?this.normalise(x.model.name).includes(query):Boolean(x.product)||x.model.tag===this.model.tag).sort((a,b)=>Number(b.model.tag===this.model.tag)-Number(a.model.tag===this.model.tag)||Number(Boolean(b.product?.available))-Number(Boolean(a.product?.available))||a.model.name.localeCompare(b.model.name,undefined,{numeric:true}));
const list=this.querySelector('[data-model-options]');list.replaceChildren();
for(const x of matches.slice(0,50)){
const li=document.createElement('li');const current=x.model.tag===this.model.tag;
const control=document.createElement(x.product?.available||current?'a':'button');
control.textContent=x.model.name;
if(control.tagName==='A'){control.href=this.link(current?location.pathname:x.product.url);if(current)control.setAttribute('aria-current','page');}
else{control.type='button';control.disabled=true;control.textContent+=' — '+(x.product?this.words.soldOut:this.words.unavailable);}
li.append(control);list.append(li);
}
this.querySelector('[data-model-status]').textContent=matches.length?this.words.modelsNote:this.words.empty;
}
async loadDesigns(){
if(this.designs){this.renderDesigns();return;}if(this.designLoading)return;
this.designLoading=true;const status=this.querySelector('[data-design-status]');status.textContent=this.words.loading;
try{const url=new URL(this.dataset.collection+'/'+this.model.tag,location.origin);
this.designs=(await this.collect(url.href)).filter(p=>p.tags.includes(this.model.tag)||p.tags.includes(this.model.name));
this.renderDesigns();
}catch{status.textContent=this.words.error;}finally{this.designLoading=false;}
}
renderDesigns(){
if(!this.designs)return;
const query=this.normalise(this.querySelector('[data-design-search]').value);
const matches=this.designs.filter(p=>this.normalise(this.designOf(p.title)||p.title).includes(query)).sort((a,b)=>Number(String(b.id)===this.dataset.productId)-Number(String(a.id)===this.dataset.productId)||Number(b.available)-Number(a.available));
const list=this.querySelector('[data-design-options]');list.replaceChildren();
for(const p of matches){
const li=document.createElement('li'),a=document.createElement('a'),label=document.createElement('span');
a.href=this.link(p.url);label.textContent=this.designOf(p.title)||p.title;
if(p.image){const img=document.createElement('img');img.src=p.image;img.alt='';img.loading='lazy';img.width=100;img.height=100;a.append(img);}
a.append(label);if(String(p.id)===this.dataset.productId){a.setAttribute('aria-current','page');const state=document.createElement('small');state.textContent=this.words.current;a.append(state);}else if(!p.available){const state=document.createElement('small');state.textContent=this.words.soldOut;a.append(state);}
li.append(a);list.append(li);
}
this.querySelector('[data-design-status]').textContent=matches.length?'':this.words.empty;
}
});